import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center justify-center rounded-[4px] border px-[10px] py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden",
  {
    variants: {
      variant: {
        tag:
          "bg-[#DBEAFE] border-transparent text-[#2563EB] font-semibold rounded-lg px-2.5 py-1 dark:bg-blue-500/20 dark:text-[#60A5FA]",
        default:
          "bg-[#DBEAFE] border-transparent text-[#2563EB] font-semibold rounded-lg px-2.5 py-1 [a&]:hover:bg-[#BFDBFE] dark:bg-blue-500/20 dark:text-[#60A5FA] dark:[a&]:hover:bg-blue-500/30",
        default2:
          "border-border border text-muted-foreground bg-card-muted font-medium rounded-lg [a&]:hover:bg-hover",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground [a&]:hover:bg-secondary/90",
        destructive:
          "border-transparent bg-destructive text-white [a&]:hover:bg-destructive/90 focus-visible:ring-destructive/20",
        outline:
          "text-foreground border-border [a&]:hover:bg-hover",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

function Badge({
  className,
  variant,
  asChild = false,
  ...props
}: React.ComponentProps<"span"> & VariantProps<typeof badgeVariants> & { asChild?: boolean }) {
  const Comp = asChild ? Slot : "span";

  return <Comp data-slot="badge" className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
